import React, {useState} from 'react';
import PropTypes from 'prop-types';
import RewardItem from './RewardItem'


const Progression = ({data, title, activeProgression, toggleProgression}) => {
    const [activeItem, setActiveItem] = useState(null);

    const onToggleItem = (data) => {
        setActiveItem(data)
    }

    const onToggleProgression = () => {
        if (title === activeProgression) {
            toggleProgression('');
        } else {
            toggleProgression(title);
        }
    }
    
    const renderList = (list) => {
        const {items, title} = list;
        if (!items.length) return;
        return (
            <div className="reward-list" key={title}>
                {items.map((item) => <RewardItem data={item} title={title} key={item.name} toggleItem={onToggleItem} /> )}
            </div>
        )
    }

    return (
        <div className={activeProgression === title ? 'accordion-wrapper active': 'accordion-wrapper'}>
            <div className="accordion-header" onClick={onToggleProgression}>{title}</div>
            <div className="accordion-content">
                {data.map((list, i) => renderList(list))}
            </div>
            {activeItem && 
                <div className="item-details">
                    <div className="inner">
                        <span className="close" onClick={() => setActiveItem(null)}/>
                        <img src={activeItem.images[0].thumbnail} alt={activeItem.name}/>
                        <div className="content">
                            <h2>{activeItem.name}</h2>
                            <h3>{activeItem.unlock}</h3>
                            <p>{activeItem.description}</p>
                        </div>
                    </div>
                </div>
            }
            
        </div>
    )
}

Progression.propTypes = {
    title: PropTypes.string,
    data: PropTypes.arrayOf(PropTypes.shape()),
    activeProgression: PropTypes.string,
    toggleProgression: PropTypes.func
}

export default Progression
